<template>
  <div
    v-if="downloads?.length"
    :class="$style.root"
  >

    <div :class="$style.label">
      {{$t('shared.downloads', { count: downloads.length })}}
    </div>

    <CoreTextComponent
      v-if="richText"
      :class="$style.richText"
      :string="richText"
    />

    <CoreDownloadsComponent
      :downloads="filesForDownload"
      viewOption="expanded"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
    downloads: {
      type: Array,
    },
    richText: {
      type: String,
      required: false,
    }
  })

  const filesForDownload = props?.downloads?.map(file => {
    return file?.file
  })?.filter(Boolean)
</script>

<style module>
.root {
  --block--margin-top: calc(var(--unit--vertical) * 2);
  --block--margin-bottom: calc(var(--unit--vertical) * 2);
}

.label {
  composes: label-border font-size-small font-helvetica from global;
}

.richText {
  margin-bottom: calc(var(--lh, 1em) / 2);
}

.link {
  composes: reset-link from global;
}
</style>
